import App from '@/models/App'

export default class OrderingOrdererShip extends App {
    static get entity() {
        return 'OrderingOrdererShips'
    }

    static all() {
        return this.query().get()
    }

    static first() {
        return this.query().withAllRecursive().first()
    }

    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
            name: this.attr(''),
        }
    }

    static apiConfig = {
        actions: {
            fetch(params) {
                return this.get(`ordering/orderer/ships`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
